export default {
  DJToJS: {
    /**
     * @typedef {Object} RepositoryDJ
     * @property {String} id - ID de la compétence
     * @property {String} name - Nom de la compétence
     * @property {DomainDJ[]} domains - Tableau des domaines rattachés au référentiel
     * @property {Number} questions_count - Nombre de questions associées
     *
     * @param repositoryDJ {RepositoryDJ}
     * @return {RepositoryAir}
     */
    convertRepository (repositoryDJ) {
      const domains = repositoryDJ.domains.map(d => this.convertDomain(d))

      return {
        id: repositoryDJ.id,
        name: repositoryDJ.name,
        type: 'repository',
        maxQuestionCount: Math.max(0, ...domains.map(domain => domain.maxQuestionCount)),
        children: domains
      }
    },
    /**
     * @typedef {Object} DomainDJ
     * @property {String} id - ID de la compétence
     * @property {String} name - Nom de la compétence
     * @property {SkillDJ[]} skills - Tableau des compétences rattachées au domaine
     * @property {Number} questions_count - Nombre de questions associées
     *
     * @param DomainDJ {DomainDJ}
     * @return {DomainAir}
     */
    convertDomain (DomainDJ) {
      const skills = DomainDJ.skills.map(skill => this.convertSkill(skill))

      return {
        id: DomainDJ.id,
        name: DomainDJ.name,
        type: 'domain',
        maxQuestionCount: Math.max(0, ...skills.map(skill => skill.maxQuestionCount)),
        children: skills
      }
    },

    /**
     * @typedef {Object} SkillDJ
     * @property {String} id - ID de la compétence
     * @property {String} name - Nom de la compétence
     * @property {String} short_name - Nom court pour affichage sur les graphiques
     * @property {Number} priority - Ordre de priorité d'affichage pour les feedbacks
     * @property {SubSkillDJ[]} subskills - Tableau des sous-compétences rattachées à la compétence
     * @property {QuestionWeightDJ[]} questions - détail des questions associées
     *
     * @param SkillDJ {SkillDJ}
     * @return {SkillAir}
     */
    convertSkill (SkillDJ) {
      const subSkills = SkillDJ.subskills.map(sub => this.convertSubSkill(sub))
      const questionCount = SkillDJ.questions.length

      return {
        id: SkillDJ.id,
        name: SkillDJ.name,
        type: 'skill',
        shortName: SkillDJ.short_name,
        priority: SkillDJ.priority,
        selected: false,
        maxQuestionCount: Math.max(questionCount, ...subSkills.map(sub => sub.questionCount)),
        questionCount,
        questions: SkillDJ.questions.map(this.convertQuestion),
        children: subSkills
      }
    },
    /**
     * @typedef {Object} SubSkillDJ
     * @property {String} id - ID de la sous-compétence
     * @property {String} name - Nom de la sous-compétence
     * @property {String} short_name - Nom court pour affichage sur les graphiques
     * @property {QuestionWeightDJ[]} questions - détail des questions associées
     *
     * @param SubSkillDJ {SubSkillDJ}
     * @return {SubSkillAir}
     */
    convertSubSkill (SubSkillDJ) {
      return {
        id: SubSkillDJ.id,
        name: SubSkillDJ.name,
        type: 'subSkill',
        shortName: SubSkillDJ.short_name,
        selected: false,
        questionCount: SubSkillDJ.questions.length,
        questions: SubSkillDJ.questions.map(this.convertQuestion)
      }
    },
    /**
     * @typedef {Object} QuestionWeightAir
     * @property {String} id - ID de la question
     * @property {String} label - libellé de la question
     * @property {Number} weight - pondération pour la compétence
     *
     * @typedef {Object} QuestionWeightDJ - question associée à une compétence
     * @property {String} question_id - ID de la question
     * @property {String} question_label - libellé de la question
     * @property {Number} weight - pondération pour la compétence
     *
     * @param {QuestionWeightDJ} questionWeightDJ
     * @return {QuestionWeightAir}
     */
    convertQuestion (questionWeightDJ) {
      return {
        id: questionWeightDJ.question_id,
        label: questionWeightDJ.question_label,
        weight: questionWeightDJ.weight
      }
    }
  },
  /**
   */
  JSToDJ: {}
}
